<script>
  export let image = null
  export let overlay = ''

  const { src, alt } = image
</script>

<div class="container">
  <img {src} {alt} />

  {#if overlay}
    <span class="overlay">{overlay}</span>
  {/if}
</div>

<style>
  .container {
    position: relative;
    width: 100%;
    height: 100%;
  }

  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }

.overlay {
  position: absolute;
  bottom: 0;
  right: 0;
  
  padding: var(--spacer-sm);
  background: var(--color-grey);
  opacity: var(--opacity-mid);
}
</style>